import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D326 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D326 - Advanced Data Management</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 6.58 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This course is really easy, contrary to all the nightmare Reddit
            posts I’ve seen. Mainly because I did all the labs for D427 (the
            course before this one), so writing SQL in this course was a breeze.
          </p>
          <p>
            Don’t overcomplicate the two reports you have to make. Keep it as
            simple as possible. If you’re stuck, ask ChatGPT for suggestions. I
            originally started with a complex report and gave up—keeping it
            simple is honestly the best strategy.
          </p>
          <p>
            This is probably the deciding factor for the course. To give you an
            idea of what the end result should look like, here’s my video
            walkthrough:
            <br />
            🔗{" "}
            <a href="https://wgu.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=177dc03f-cb3e-4b72-9e86-b22d006c504b" target="_blank" rel="noreferrer">
              Watch here
            </a>
          </p>
          <p>
            Not much else to say—it’s basically just using a database, making
            two smaller tables, and submitting them as reports.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D326;
